// angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MePasswordResetService } from './password-reset.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'me-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    providers: [MePasswordResetService]
})

export class MePasswordResetComponent implements OnInit {
    email = '';
    form : FormGroup;
    submitted = false;
    hidePassword = false;
    token = '';
    errorMessage = '';

    constructor(
        public service: MePasswordResetService,
        public route : ActivatedRoute,
        public router: Router,
        public fb: FormBuilder,
        public coreService : CoreService,
        public appService: AppService
    ) {
    }

    ngOnInit() {
        this.appService.isLoading = false;
        
        this.form = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(8)]],
        });

        this.route.params.subscribe(params => {
            this.token = params['token'];
        })
    }

    submit(value, isValid) {
        this.submitted = true;
        if (!isValid) {
            return;
        }
        
        this.appService.isLoading = true;
        this.service.changePassword(this.token,value.password,value.password).subscribe((res) => {
            this.appService.isLoading = false;
            this.router.navigate(['/me/login']);
        },
        (error) => {
            this.errorMessage = error.error.error;
            this.appService.isLoading = false;
        });
    }
}
